import { buttonClasses } from '@mui/material'
import { C1Button, C1ButtonProps } from 'c1ui'
import { FC, ReactNode } from 'react'

type LoginButtonProps = Omit<C1ButtonProps, 'variant' | 'color'> & {
    children: ReactNode
}

export const LoginButton: FC<LoginButtonProps> = ({ children, ...props }) => <C1Button
    variant="contained"
    color="primary"
    sx={{
        maxHeight: 'none',
        [`&.${buttonClasses.root}`]: {
            px: 6,
            py: 3,
        },
    }}
    {...props}
>
    {children}
</C1Button>
